import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "inline-block nes-text is-primary" }, "(?)", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "inline-block nes-text is-primary" }, "(?)", -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.external)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: _ctx.external,
        target: "_blank"
      }, _hoisted_3, 8, _hoisted_1))
    : (_openBlock(), _createElementBlock("a", _hoisted_4, _hoisted_6))
}